import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  DatePicker,
  Table,
  Typography,
  Spin,
  Popconfirm,
} from "antd";

import { PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import Page from "_components/Page";
import { stockReceiptService, companyService } from "_services";
import { Auth } from "_helpers";
import { AddReciptTabMenu } from "./TabMenu";
import AddMaterialDrawer from "./Drawer";

let lineIndex = 0;

function TiepRecieptImported({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [orderLines, setOrderLines] = useState([]);
  const [selectedcustomer, setSelectedcustomer] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedOrderDate, setSelectedOrderDate] = useState(Date());
  const [error, setError] = useState(null);
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  //const [stockClasses, setStockClasses] = useState([]);
  //const [selectedStockClass, setSelectedStockClass] = useState(null);
  const [loadingAddItem, setLoadingAddItem] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [form] = Form.useForm();
  const [addEditStockItemForm] = Form.useForm();
  const { Option } = Select;
  const { Text } = Typography;
  const precision = 2;

  //let lineIndex = 0;
  const isLoggedInCustomer = () => {
    return Auth.hasRole(Auth.getProfile(), ["CAU"]);
  };

  useEffect(() => {
    //stop refresh the site while editing
    const unloadCallback = (event) => {
      const e = event || window.event;
      //console.log(e)
      e.preventDefault();
      if (e) {
        e.returnValue = "";
      }
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);

    companyService.getAll().then((x) => {
      setStores(x.content);
    });

    let companyId = Auth.getProfile().comp_id;

    companyService.getById(companyId).then((data) => {
      const grantedStoreAddresses = data.content.addresses.filter(
        (item) => item.addressType === "WAREHOUSE"
      );
      const officeAddresses = data.content.addresses.filter(
        (item) => item.addressType === "OFFICE"
      );

      form.setFieldsValue({
        storeAddress:
          grantedStoreAddresses.length === 1 ? grantedStoreAddresses[0] : null,
        customer: data.content,
        customerAddress: officeAddresses[0],
      });

      setStoreAddresses(grantedStoreAddresses);
      setcustomers([data.content]);
      setcustomerAddresses(officeAddresses);
      setSelectedcustomer(data.content);
    });

    return () => {
      //cleanup function
      window.removeEventListener("beforeunload", unloadCallback);
    };
  }, []);

  const getcustomerAddresses = (companyId) => {
    companyService.getById(companyId).then((x) => {
      setcustomerAddresses(
        x.content.addresses.filter(
          (address) => address.addressType === "OFFICE"
        )
      );
    });
  };

  const handleFormSumbit = () => {
    let payload = {
      CusDecNo: null,
      CusDecDate: null,

      supplier: { id: null },
      exporter: { id: null },
      consignee: { id: null },
      declarent: { id: null },
      currency: { id: null },
      exchangeRate: null,
      totalInvoiceAmountRecipt: null,

      bank: {
        name: null,
        branch: null,
        paymentType: null,
        paymentReferenceNo: null,
      },

      goodsReceivedNote: "",
      goodsRecivedPerson: null,

      receiptType: null,
      orderDate: null,
      expectedDate: null,
      receivedDate: null,
      remark: null,

      preReceiptNumber: null,

      stockReceiptLines: [
        {
          stockType: {
            id: null,
          },
          stockBin: {
            id: null,
          },

          measurementType: {
            id: null,
          },

          packingType: {
            id: null,
          },
          itemQuantity: null,
          quantityPerItem: null,
          netWeight: null,
          grossWeight: null,
        },
      ],
    };

    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        payload.CusDecNo = values.cusDecNo;
        payload.CusDecDate = moment(values.date).format("YYYY-MM-DD");
        payload.exporter.id = values.exporterID;
        payload.consignee.id = values.consigneeID;
        payload.declarent.id = values.declarentID;

        payload.receivedDate = moment(values.receivedDate).format("YYYY-MM-DD");
        payload.currency = values.currency;
        payload.exchangeRate = values.exchangeRate;
        payload.totalInvoiceAmountRecipt = values.totalInvoiceAmount;

        payload.bank.name = values.bankName;
        payload.bank.branch = values.bankBranch;
        payload.bank.paymentType = values.pmtType;
        payload.bank.paymentReferenceNo = values.bnkRefNo;
        payload.bank.paymentReferenceNo = values.bnkRefNo;

        payload.stockReceiptLines = orderLines.map((line) => ({
          stockType: { id: line.materialId },

          measurementType: {
            id: line.uomId,
          },

          packingType: {
            id: line.packingId,
          },
          itemQuantity: line.numberOfUnits,
          quantityPerItem: line.quantityPerUnit,
          netWeight: line.netweight,
          grossWeight: line.grossWeight,
        }));

        stockReceiptService
          .create(payload)
          .then((response) => {
            console.log(response);
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.log(error);
        return;
      });
  };

  const onCancel = () => {
    history.push(".");
  };

  const getRowBykey = (key, newData) => {
    return (orderLines || newData).filter((item) => item.key === key)[0];
  };

  const handleAddOrderLine = () => {
    setEditDrawerVisible(true);
  };

  const handleRemoveOrderLine = (orderLine) => {
    const lines = [...orderLines];
    if (lines.includes(orderLine)) {
      lines.splice(lines.indexOf(orderLine), 1);
      setOrderLines(lines);
    }
  };

  const orderLineColumns = [
    {
      title: "Hscode",
      dataIndex: "hscode",
      key: "hscode",
      width: "10%",
      render: (text, record) => {
        return record?.hscode ?? "";
      },
    },

    {
      title: "Packing Type",
      dataIndex: "packingType",
      key: "packingType",
      align: "center",
      width: "10%",
      render: (text, record) => {
        return record.packingType ?? "";
      },
    },

    {
      title: "Net Weight(Kg)",
      dataIndex: "netweight",
      align: "center",
      key: "netweight",
      width: "20%",
      render: (text, record) => {
        return record.netweight ?? "";
      },
    },

    {
      title: "Gross Weight(Kg)",
      dataIndex: "grossWeight",
      align: "center",
      key: "grossWeight",
      width: "20%",
      render: (text, record) => {
        return record.grossWeight ?? "";
      },
    },

    {
      title: "Number Of units",
      dataIndex: "numberOfUnits",
      key: "numberOfUnits",
      align: "center",
      width: "10%",
      render: (text, record) => {
        return record.numberOfUnits ?? 1;
      },
    },

    {
      title: "UOM",
      dataIndex: "uom",
      align: "center",
      key: "uom",
      width: "5%",
      render: (text, record) => {
        return record.uom?.name ?? "";
      },
    },

    {
      title: "Quantity Per Unit",
      dataIndex: "quantityPerUnit",
      key: "quantityPerUnit",
      align: "center",
      width: "10%",
      render: (text, record) => {
        return record.quantityPerUnit ?? "";
      },
    },
  ];
  const onCloseAddEditStockItemDrawer = () => {
    setEditDrawerVisible(false);
  };
  const handleAddEditStockItem = (data) => {
    setIsLoading(true);
    console.log(data);
    setOrderLines((currentItems) => [...currentItems, { ...data }]);
    setIsLoading(false);
    setEditDrawerVisible(false);
  };
  const handleSearch = (searchText) => {
    setOptions(
      materialTypes?.map((item) => ({
        value: item.name,
        key: item.id,
        code: item.code,
      }))
    );

    if (!searchText) {
      setFilteredOptions(options); // Reset options if search text is empty
    } else {
      const filtered = options.filter((option) =>
        option.value.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipts Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts/imported">Imported Receipt</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Popconfirm
            title="Are you sure to add the changes?"
            onConfirm={handleFormSumbit}
            key="add-confirm"
          >
            <Button
              key="1"
              type="primary"
              htmlType="submit"
              loading={isLoading}
              //onClick={handleFormSumbit}
              disabled={orderLines.length == 0}
            >
              Save
            </Button>
          </Popconfirm>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error}>
          <AddReciptTabMenu menu="imported" />

          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={3}>
                  <Form.Item
                    name={["cusDecNo"]}
                    rules={[
                      {
                        required: true,
                        message: "There should be a reference number!",
                      },
                    ]}
                    label="CusDec No*"
                    tooltip={{
                      title: "Cutom Reference Number From the Import Document",
                      icon: <InfoCircleOutlined />,
                    }}
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={3}>
                  <Form.Item
                    name={["date"]}
                    rules={[
                      { required: true, message: "There should be a date!" },
                    ]}
                    label="Date*"
                  >
                    <DatePicker
                      placeholder="Customs date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["exporter"]}
                    rules={[{ required: false }]}
                    label="Exporter"
                  >
                    <Select
                      placeholder="Please select"
                      onChange={(selected, option) =>
                        form.setFieldValue("exporterID", option.key)
                      }
                      allowClear
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={"consignee"}
                    rules={[{ required: false }]}
                    label="Consignee"
                  >
                    <Select
                      placeholder="Please select"
                      onChange={(selected, option) =>
                        form.setFieldValue("consigneeID", option.key)
                      }
                      allowClear
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["declarent"]}
                    rules={[{ required: false }]}
                    label="Declarent"
                  >
                    <Select
                      placeholder="Please select"
                      onChange={(selected, option) =>
                        form.setFieldValue("declarentID", option.key)
                      }
                      allowClear
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["receivedDate"]}
                    rules={[{ required: false }]}
                    label="Received Date"
                    initialValue={moment()}
                  >
                    <DatePicker
                      placeholder="Received date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["currency"]}
                    rules={[
                      {
                        required: true,
                        message: "There should be currency type",
                      },
                    ]}
                    label="Currency*"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["exchangeRate"]}
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                    label="Exchange Rate*"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["totalInvoiceAmount"]}
                    rules={[
                      { required: true, message: "There should be a amount" },
                    ]}
                    label="Total Invoiced Amount*"
                  >
                    <Input type="number"></Input>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["bankName"]}
                    rules={[{ required: false }]}
                    label="Bank*"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["bankBranch"]}
                    rules={[{ required: false }]}
                    label="Branch*"
                  >
                    <Input type="number"></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["pmtType"]}
                    rules={[{ required: false }]}
                    label="Payment Type"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["bnkRefNo"]}
                    rules={[{ required: false }]}
                    label="Payment Reference No"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name="declarentID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="exporterID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name="consigneeID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>
              </Row>

              <Button
                style={{
                  width: "100%",
                  color: "black",
                  fontWeight: "bold",
                  marginTop: 16,
                  marginBottom: 8,
                  background: "rgb(190, 200, 200)",
                }}
                type="dashed"
                onClick={handleAddOrderLine}
                icon={<PlusOutlined />}
              >
                Add Item
              </Button>

              <AddMaterialDrawer
                onDrawerClose={onCloseAddEditStockItemDrawer}
                isDrawerOpen={editDrawerVisible}
                title="Add Material"
                finishSubmit={handleAddEditStockItem}
                isloading={isLoading}
              />

              {orderLines && (
                <Table
                  bordered
                  pagination={false}
                  columns={orderLineColumns}
                  dataSource={orderLines}
                  size="small"
                />
              )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default TiepRecieptImported;
